import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-date',
  templateUrl: './attr-date.component.html',
  styleUrls: ['./attr-date.component.scss'],
  standalone: false,
})
export class AttrDateComponent implements OnInit {
  @Input() propertyId: string;
  @Input() caption: string;
  @Input() value: Date;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;

  constructor() {}

  ngOnInit(): void {}
}
